import { Outlet, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectIsAuthenticated } from "../../store/slices/authSlice";

/**
 * PrivateRoutes — Protects authenticated routes.
 * Reads from Redux (persisted auth slice) rather than raw localStorage
 * so it stays reactive to login/logout actions.
 */
const PrivateRoutes = () => {
  const isAuthenticated = useSelector(selectIsAuthenticated);

  return isAuthenticated ? <Outlet /> : <Navigate to="/" replace />;
};

export default PrivateRoutes;
